import React from "react";
import { FiMail } from "react-icons/fi";
import Typewriter from "typewriter-effect";

const ProfileData = () => {
  return (
    <div className="home_data">
      <h2 className="home_title text-4xl font-bold text-gray-200 mb-2">
        Nazmus Sakib
      </h2>
      <h3 className="text-xl font-semibold text-gray-300 mb-4">
        <Typewriter
          options={{
            strings: [
              "Software Engineer",
              "FullStack Developer",
              "ReactJS Developer",
              "MERN Stack Developer",
            ],
            autoStart: true,
            loop: true,
            wrapperClassName: "home_subtitle",
          }}
        />
      </h3>
      <p className="home_description text-gray-300 mb-6">
        Passionate and dedicated to software development
      </p>
      <a
        href="/contact"
        className="btn bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold flex items-center py-3 px-8 rounded-full shadow-md transition duration-300"
      >
        <FiMail className="mr-2" />
        Say Hello
      </a>
    </div>
  );
};

export default ProfileData;
